import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor() { }

  public getDatePickerOptions(): any {
    return {
      drops: 'up',
      timePicker24Hour: true,
      alwaysShowCalendars: true,
      showDropdowns: true,
      autoUpdateInput: true,
      autoApply: true,
      timePicker: true,
      linkedCalendars: false,
      minYear: 2000,
      cancelButtonClasses: 'timeRangeApplyButton',
      locale: {
        format: 'DD-MMM-YY HH:mm',
        separator: '  —  '
      }
    };
  }
}
